import React from 'react';

/**
 * Default English wording for the {@link RefreshProductListAction} tooltip/modal, used by modules
 * that don't need a localized explanation (e.g. SK Max Price, RO Max Price).
 *
 * @returns {JSX.Element} The English description text.
 */
export function EnglishRefreshProductListDescription() {
	return (
		<>
			Clicking this button will automatically refresh prices, validities and other product details based on
			module-specific settings. Refreshing product list will overwrite all existing <strong>Use for calc.</strong> field
			settings and cannot be reverted.
		</>
	);
}
